import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = /*#__PURE__*/_createVNode("label", {
  for: "country",
  class: "col-sm-2 control-label"
}, "Country", -1)
const _hoisted_3 = { class: "col-sm-10" }
const _hoisted_4 = {
  key: 0,
  class: "form-group"
}
const _hoisted_5 = {
  for: "region",
  class: "col-sm-2 control-label"
}
const _hoisted_6 = { class: "col-sm-10" }

import { computed, PropType, ref } from 'vue'
import { countries, regions, InvalidState } from '@/modules/country-region'
import { CountryRegion } from '@/modules/backend'


export default _defineComponent({
  expose: [],
  props: {
    modelValue: { type: null, required: true },
    disabled: { type: null, required: true }
  } as unknown as undefined,
  emits: ['update:modelValue'],
  setup(__props: {
	modelValue: CountryRegion,
	disabled: Boolean
}, { emit }) {






const country = ref("")
const region = ref("")

const currentRegions = computed(
	() => country.value in regions ? regions[country.value] : null
)

function countryChanged() {
	region.value = ""
	regionChanged()
}

function regionChanged() {
	let countryRegion: CountryRegion | InvalidState

	if (currentRegions.value == null) countryRegion = { country: country.value, region: null }
	else if (region.value == "") country.value == "CA" ? countryRegion = "MissingProvince" : countryRegion = "MissingState"
	else countryRegion = { country: country.value, region: region.value }

	emit('update:modelValue', countryRegion)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode("div", _hoisted_3, [
        _withDirectives(_createVNode("select", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (country.value = $event)),
          id: "country",
          class: "form-control",
          onChange: countryChanged,
          disabled: __props.disabled
        }, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_unref(countries), (code, name) => {
            return (_openBlock(), _createBlock("option", {
              key: code,
              value: code
            }, _toDisplayString(name), 9, ["value"]))
          }), 128))
        ], 40, ["disabled"]), [
          [_vModelSelect, country.value]
        ])
      ])
    ]),
    (_unref(currentRegions) != null)
      ? (_openBlock(), _createBlock("div", _hoisted_4, [
          _createVNode("label", _hoisted_5, _toDisplayString(country.value == "CA" ? "Province" : "State"), 1),
          _createVNode("div", _hoisted_6, [
            _withDirectives(_createVNode("select", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (region.value = $event)),
              id: "region",
              class: "form-control",
              onChange: regionChanged,
              disabled: __props.disabled
            }, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_unref(currentRegions), (code, name) => {
                return (_openBlock(), _createBlock("option", {
                  key: code,
                  value: code
                }, _toDisplayString(name), 9, ["value"]))
              }), 128))
            ], 40, ["disabled"]), [
              [_vModelSelect, region.value]
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})